import { DcMotor } from './DcMotor'
import { cross, multiply, add } from './vectors'

function sixWheelOmni(motor_type, mass, wheel_mass, wheel_radius, width, height) {
    return [
        {
            name: 'left',
            motor: new DcMotor(motor_type, mass, wheel_mass, wheel_radius, 2),
            position: { x: -width/2, y: 0 }
        },
        {
            name: 'right',
            motor: new DcMotor(motor_type, mass, wheel_mass, wheel_radius, 2),
            position: { x: width/2, y: 0 }
        }
    ]
}

let sqrt_two = Math.sqrt(2)

function mecanum(motor_type, mass, wheel_mass, wheel_radius, width, height) {
    return [
        {
            name: 'frontLeft',
            motor: new DcMotor(motor_type, mass, wheel_mass, wheel_radius, 4),
            position: { x: -width/2, y: height/2 },
            angle: -0.785398,
            coefficient: sqrt_two
        },
        {
            name: 'frontRight',
            motor: new DcMotor(motor_type, mass, wheel_mass, wheel_radius, 4),
            position: { x: width/2, y: height/2 },
            angle: 0.785398,
            coefficient: sqrt_two
        },
        {
            name: 'backLeft',
            motor: new DcMotor(motor_type, mass, wheel_mass, wheel_radius, 4),
            position: { x: -width/2, y: -height/2 },
            angle: 0.785398,
            coefficient: sqrt_two
        },
        {
            name: 'backRight',
            motor: new DcMotor(motor_type, mass, wheel_mass, wheel_radius, 4),
            position: { x: width/2, y: -height/2 },
            angle: -0.785398,
            coefficient: sqrt_two
        }
    ]
}

function omniDrive(motor_type, mass, wheel_mass, wheel_radius, width, height) {
    return [
        {
            name: 'frontLeft',
            motor: new DcMotor(motor_type, mass, wheel_mass, wheel_radius, 4),
            position: { x: -width/2, y: height/2 },
            angle: -0.785398,
        },
        {
            name: 'frontRight',
            motor: new DcMotor(motor_type, mass, wheel_mass, wheel_radius, 4),
            position: { x: width/2, y: height/2 },
            angle: 0.785398,
        },
        {
            name: 'backLeft',
            motor: new DcMotor(motor_type, mass, wheel_mass, wheel_radius, 4),
            position: { x: -width/2, y: -height/2 },
            angle: 0.785398,
        },
        {
            name: 'backRight',
            motor: new DcMotor(motor_type, mass, wheel_mass, wheel_radius, 4),
            position: { x: width/2, y: -height/2 },
            angle: -0.785398,
        }
    ]
}

function slideDrive(motor_type, mass, wheel_mass, wheel_radius, width, height) {
    return [
        {
            name: 'left',
            motor: new DcMotor(motor_type, mass, wheel_mass, wheel_radius, 2),
            position: { x: -width/2, y: 0 }
        },
        {
            name: 'right',
            motor: new DcMotor(motor_type, mass, wheel_mass, wheel_radius, 2),
            position: { x: width/2, y: 0 }
        },
        {
            name: 'slide',
            motor: new DcMotor(motor_type, mass, wheel_mass, wheel_radius, 3),
            position: { x: width/2, y: 0 },
            angle: -1.5708
        }
    ]
}
        
export { sixWheelOmni, mecanum, slideDrive, omniDrive }


//////////////////
// WEBPACK FOOTER
// ./src/drivetrains.js
// module id = 17
// module chunks = 0